import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { BdCompanyGroup } from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';
import { BdPermissionsGroupsStore } from '../store/group/groups.store';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class BdPermissionsGroupsService {
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private readonly _store: BdPermissionsGroupsStore;

  constructor() {
    this._store = new BdPermissionsGroupsStore(this._environmentService.load(ApiEndpointKey.BD_PERMISSION_RESOURCE_URL));
  }

  public byId(groupId: string): Observable<BdCompanyGroup | null> {
    const url = this._store.getById(groupId);
    return this._httpClient.get<BdCompanyGroup>(url);
  }
}
